import styled from 'styled-components';

export const Container = styled.div`
min-height: 120vh;
position: relative;
text-align: center;
color: white;
padding: 0 30px 30px;
margin: 0 auto;
`;

export const Title = styled.div`
max-width: 800;
margin: 0 auto;
`;

export const BioWrapper = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding-top: 15px;
  @media only screen and (max-width: 1080px) {
    flex-direction: column;
  }
`;

export const ImageWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
img {
max-width: 85%;
height: auto;
z-index: 1;
border-radius: 2%;
filter: brightness(80%);
@media only screen and (max-width: 950px) {
max-width: 100%;
filter: brightness(100%);
}
}


`;

export const DescriptionTextWrapper = styled.div`
max-width: 40%;
font-size: calc(4px + 1vw);
font-family: 'Lato',sans-serif;
color: lightblue;
margin: auto;
  @media only screen and (max-width: 1080px) {
padding-top: 20px;
font-size: calc(14px + 1vw);
max-width: 95%;
  }
`;
